import React, { Children, cloneElement } from 'react';
import type { FC, ReactNode } from 'react';
import type { IFeedCardAsset } from '@alfa-bank/site-invest-emitents-common/src/models';

import { createArrayWithCustomElement } from '../../helpers';

import type { TFeedView } from './models';

export const FeedView: FC<TFeedView> = ({
    Card,
    Carousel,
    NotFoundAssets,
    analytics,
    assets,
    cardHasBorder = false,
    cardTheme,
    children,
    className,
    customCardPosition,
    notFoundBlockSettings,
    proportion,
}) => {
    if (!assets?.length) {
        return (
            <NotFoundAssets
                description={notFoundBlockSettings.description}
                title={notFoundBlockSettings.title}
            />
        );
    }

    let customCard: ReactNode = null;
    const isOnlyOneNode = Children.count(children) === 1;

    // Пока обрабатываем только кейс с тем, что карточка может быть только одна
    // Если нод в слоте больше или вообще ничего нет, игнорируем слот
    if (isOnlyOneNode) {
        customCard = cloneElement(<>{children}</>, { proportion });
    }

    const renderAssetCard = (asset: IFeedCardAsset) => (
        <Card
            key={asset.ISIN}
            analytics={analytics?.clickCardFeed}
            asset={asset}
            cardTheme={cardTheme}
            dataTestId="card-feed"
            hasBorder={cardHasBorder}
            proportion={proportion}
        />
    );

    const elements = createArrayWithCustomElement({
        array: assets,
        mapFn: renderAssetCard,
        customElement: customCard,
        customElementPosition: customCardPosition,
    });

    return (
        <section className={className} data-test-id="feed-section">
            <Carousel analytics={analytics?.scrollCarouselFeed}>{elements}</Carousel>
        </section>
    );
};
